<template>
<div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'system-admin-template-approval-list'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Template Approval</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'system-admin-template-approval-list'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addtemplate">Create</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
        <div class="container-wrapper">
            <primary-input type="text"
                           name="template name"
                           class="field"
                           v-model="template.template_name"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('template name')}"
                           placeholder="Type a name of Template" />
            <div class="help is-danger"
                v-if="errors.has('template name')">
            {{ errors.first('template name') }}
            </div>
            <div class="help is-danger"
                v-if="contactError">
            {{contactError.template_name ? contactError.template_name[0] : null}}
            </div>  
            <text-area placeholder="Enter sms text"
                    v-model="template.sms_text"
                    maxlength="160"
                    class="sms_text field"
                    name="sms text" />            
            <div class="help is-danger"
                v-if="errors.has('sms text')">
            {{ errors.first('sms text') }}
            </div>
            <div class="help is-danger"
                v-if="contactError">
            {{contactError.sms_text ? contactError.sms_text[0] : null}}
            </div>                 
        </div>
    </div>
</div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
    TextArea: () => import('@/components/Inputs/TextArea.vue'),
  },
  data: () => ({
    contactError: null,
    template: {
      template_name: "",
      sms_text: "",
      company_uuid: "",
    },
  }),
  created() {
  },
  methods: {
    addtemplate() {
        console.log("this.template", this.template);
      this.$validator.validate().then(result => {
        if (result) {
            this.template.company_uuid = this.$store.state.company.company.company_uuid;
            console.log("template-->", this.template)
          this.$store
            .dispatch("AddTemplate", {
              template: this.template
            })
            .then(() => {
              this.$snotify.success("Template Approval added.", {
                timeout: 6000
              });
                this.$router.push({ name: "system-admin-template-approval-list" });
            })
            .catch(err => {
              if (err.errors) {
                this.contactError = err.errors[0].template
                  ? err.errors[0].template
                  : null;
                setTimeout(() => {
                  this.contactError = null;
                }, 6000);
              } else {
                this.$snotify.error(err.error.message, {
                  timeout: 6000
                });
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container{
    font-family: "Helvetica Neue";
    padding: 0 20px;
    .add-navigation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        .back-link {
            cursor: pointer;
            display: flex;
            align-items: center;
            fill: #51a3f3;
            color: #51a3f3;
            font-family: "Helvetica Neue";
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
        }
        .buttons-wrapper {
            display: flex;
            align-items: center;
            width: fit-sms_text;
            .primary-button {
                height: 40px;	
                width: 90px;
            }
            .secondary-button {
                height: 40px;	
                width: 90px;
                margin-right: 15px;
            }
        }
    }
    .add-container {
        flex-direction: column;
        align-items: center;
        height: 221px;	
        width: 450px;
        font-family: "Helvetica Neue";
        .container-wrapper {
            width: 100%;
            margin-left: 15px;
            margin-top: 20px;
            .field {
                margin-top: 15px;               
            }            
        }
        .email-input {
            margin-bottom: 20px;
        }
        .password-input {
            margin-bottom: 30px;
        }
        .first {
            margin-bottom: 30px;
            .remember-me {
                display: flex;
                align-items: center;
                input {
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>

